
import { getCourseId,removeCourseId, getOrder, removeOrder } from '@/utils/order'
import { getRemark, removeRemark } from '@/utils/remark'

// 村赤用户令牌和角色信息
const state ={
    order: getOrder() || '',
    remark:getRemark() || '',
    courseId:getCourseId() || '',
    
}

const mutations ={
    SET_ORDER: (state,info) => {
        state.order = info;
    },
    SET_REMARK: (state,info) => {
        state.remark = info;
    },
    SET_ID: (state,info) => {
        state.courseId = info;
    },
    
  
};

const actions = {
    addOrder({commit},info){
        commit('SET_ORDER',info)
    },
    // 重置令牌
    resetOrder( {commit} ){
            commit('SET_ORDER','')
            removeOrder();
            // resolve()
    },

    addRemark({commit},info){
        commit('SET_REMARK',info)
    },
    // 重置令牌
    resetRemark( {commit} ){
            commit('SET_REMARK','')
            removeRemark();
            // resolve()
    },

    addId({commit},info){
        commit('SET_ID',info)
    },
    // 重置令牌
    resetId( {commit} ){
            commit('SET_ID','')
            removeCourseId();
            // resolve()
    },
   
   
   
  
}

export default {
    // namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/order.js